import { createSlice } from "@reduxjs/toolkit";
import { fetchWaitlistItems, postWaitlistItem } from "./WaitlistThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const waitlistSlice = createSlice({
  name: "waitlist",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWaitlistItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWaitlistItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchWaitlistItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // ✅ Post Thunk
      .addCase(postWaitlistItem.pending, (state) => {
        state.postStatus = "loading";
        state.error = null;
      })
      .addCase(postWaitlistItem.fulfilled, (state, action) => {
        state.postStatus = "succeeded";
        state.items.push(action.payload); // optional: add new item to state
      })
      .addCase(postWaitlistItem.rejected, (state, action) => {
        state.postStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default waitlistSlice.reducer;
